import Modal from 'components/Luxkit/Modal/Modal'
import React from 'react'
import ReserveForZeroPolicyModalContent from './ReserveForZeroPolicyModalContent'
import { useTranslation } from 'react-i18next'

interface Props {
  isOpen?: boolean;
  onClose?: (event?: React.MouseEvent<HTMLButtonElement>) => void
}

function ReserveForZeroPolicyModal(props: Props) {
  const { isOpen, onClose } = props
  const { t } = useTranslation('hotelOfferList')

  return (
    <Modal
      title={t('Reserve now for free', { ns: 'hotelOfferList' })}
      isOpen={isOpen}
      onClose={onClose}
      height="full"
      desktopHeight="auto"
      subtitle={t('reserveNowForFreeSubtitle', { ns: 'hotelOfferList' })}
      size="large"
    >
      <ReserveForZeroPolicyModalContent />
    </Modal>
  )
}

export default ReserveForZeroPolicyModal
